export const apiDocs = [
  {
    id: 1,
    title: "SOP for Label Printer Setting",
    subtitle: "Configuration & Setup Guide",
    fileType: "pdf", // or 'folder', 'doc', etc.
    size: "2.4 MB",
    date: "2023-10-15",
    author: "Admin", // Placeholder
    downloadLink: "https://drive.google.com/uc?id=YOUR_FILE_ID_HERE&export=download", // Placeholder
    iconColor: "#f59e0b" // Orange/Yellow like folder in image
  },
  {
    id: 2,
    title: "SOP of Printer Calibration",
    subtitle: "Calibration Instructions",
    fileType: "pdf",
    size: "1.8 MB",
    date: "2023-11-20",
    author: "Support",
    downloadLink: "https://drive.google.com/uc?id=YOUR_FILE_ID_HERE&export=download",
    iconColor: "#3b82f6" // Blue like folder in image
  },
  {
    id: 3,
    title: "SOP how to RFID Dashboard",
    subtitle: "User Guide & Manual",
    fileType: "pdf",
    size: "5.2 MB",
    date: "2024-01-10",
    author: "Tech Team",
    downloadLink: "https://drive.google.com/uc?id=YOUR_FILE_ID_HERE&export=download",
    iconColor: "#ef4444" // Red like folder in image
  }
];
